<div class="qr-code">
  <ngx-qrcode
          [elementType]="elementType"
          [errorCorrectionLevel]="correctionLevel"
          [value]="value"
          [margin]="margin"></ngx-qrcode>
</div>
